<template>
  <!-- <v-dialog :scrollable="true" v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="headline">configurar validacion ftp</v-card-title>
      <v-card-text>
        Aqui va la lista de direcciones ftp que se van a investigar
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-2" flat="flat" @click.native="dialog = false">Cerrar</v-btn>
        <v-btn color="blue darken-1" flat="flat" @click.native="configure()">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
  <v-dialog v-model="dialog" max-width="500px" scrollable>
    <v-card>
      <v-card-title class="headline">Rutas</v-card-title>
      <v-divider></v-divider>
      <div>
        <v-container class="py-0 pb-3">
          <v-layout wrap>
            <v-flex>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="distributorFilter"
                    label="Distribuidora"
                    hide-details
                    clearable
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-divider></v-divider>
      <v-card-text class="py-2" style="height: auto">
        <v-container class="px-3 py-0">
          <v-layout row>
            <v-flex>
              <template v-if="filteredDistributors.length > 0">
                <template v-for="(item, index) in filteredDistributors">
                  <div :key="'c'+index">
                    <v-layout row wrap>
                      <v-flex sm10 xs12 class="align-center layout">
                        <template v-if="editedIndex > -1 && editedIndex === index">
                          <v-text-field hide-details class="py-1" v-model="editedItem.remoteFileName"></v-text-field>
                          <v-btn small icon class="mx-2" @click="close">
                            <v-icon color="red">clear</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <b>{{ item.distributorName || '~NO DEFINIDO~' }}</b>&nbsp;&nbsp;-&nbsp;&nbsp;<span>{{ item.remoteFileName || '~RUTA NO DEFINIDA~' }}</span>
                        </template>
                      </v-flex>
                      <v-flex sm2 xs12>
                        <v-layout row>
                          <v-flex xs6 class="justify-center layout">
                            <template v-if="editedIndex > -1 && editedIndex === index">
                              <v-btn small icon class="mx-0" @click="save">
                                <v-icon color="blue">save</v-icon>
                              </v-btn>
                            </template>
                            <template v-else>
                              <v-btn small icon class="mx-0" @click="editItem(item)">
                                <v-icon color="blue">edit</v-icon>
                              </v-btn>
                            </template>
                          </v-flex>
                          <v-flex xs6 class="justify-center layout">
                            <v-btn small icon :disabled="editedIndex > -1 && editedIndex === index" class="mx-0" @click="deleteItem(item)">
                              <v-icon color="red">delete</v-icon>
                            </v-btn>

                          </v-flex>

                        </v-layout>

                      </v-flex>

                    </v-layout>
                  <!-- </v-list-tile> -->
                  </div>
                  <v-divider v-if="index + 1 < filteredDistributors.length" :key="index"></v-divider>
                </template>
              </template>
              <template v-else>
                <v-container>
                  <v-layout wrap>
                    <v-flex style="color:rgba(0,0,0,.38)" class="align-center layout">
                      No data available
                    </v-flex>
                  </v-layout>

                </v-container>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="blue darken-1" @click.native="dialog = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import {filter, orderBy} from 'lodash'

import eventBus from '../../utils/eventBus'

import supervisorStorage from '../../storage/supervisorStorage'

export default {
  name: 'configure-ftp-dialog',
  created () {
    eventBus.$off('open-configure-ftp')
    eventBus.$on('open-configure-ftp', (data) => {
      console.log('wdf')
      this.dialog = true

      this.initialize()
    })
  },
  data () {
    return {
      dialog: false,
      distributorFilter: '',
      items: [],
      editedIndex: -1,
      editedItem: {
        distributorID: 0,
        remoteFileName: ''
      },
      defaultItem: {
        distributorID: 0,
        remoteFileName: ''
      }
    }
  },
  /* methods: {
    configure () {

    }
  } */
  methods: {
    initialize () {
      this.getRemoteFiles()
    },

    editItem (item) {
      this.editedIndex = this.filteredDistributors.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // this.dialog = true
    },
    deleteItem (item) {
      // emit to: /components/dialogs/are-you-sure-dialog.vue
      eventBus.$emit('open-are-you-sure-dialog', {
        title: 'Eliminar',
        message: '¿Estás seguro de que deseas borrar esta ruta?',
        onOk: () => {
          supervisorStorage.removeSupervisorFtpFile({
            data: {
              item: item
            }
          })
        }
      })
    },
    close () {
      // this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 100)
    },
    save () {
      // VALIDAR DATOS DE ENTRADA
      if (this.editedItem.remoteFileName.trim() !== '') {
        if (this.editedIndex > -1) {
          // Object.assign(this.items[this.editedIndex], this.editedItem)
          supervisorStorage.updateSupervisorFtpFile({
            data: {
              item: this.editedItem
              // index: this.editedIndex // PODRIA TOMARSE CON LODASH, EN EL STORAGE
            }
          })
          // let item =
          /* supervisorStorage.updateSupervisorFtpFile({
            data: {
              item: this.item,
              newItem: this.editedItem // PODRIA TOMARSE CON LODASH, EN EL STORAGE
            }
          }) */
        }/*  else {
          // this.items.push(this.editedItem)
          supervisorStorage.addSupervisorFtpFile({
            data: {
              item: this.editedItem
            }
          })
        } */
        this.close()
      } else {
        // ALERTA, NO HAY REMOTEFILENAME INGRESADO
      }
    },
    getRemoteFiles () {
      this.items = supervisorStorage.getSupervisorFtpFiles()
    }
  },
  computed: {
    filteredDistributors () {
      let filtered = filter(this.items, (item) => {
        // return item.distributorName.toLowerCase().includes((this.distributorFilter || '').toLowerCase())
        return item.distributorName.toLowerCase().indexOf((this.distributorFilter || '').toLowerCase()) !== -1
      })
      let sorted = orderBy(filtered, ['distributorName', 'remoteFileName'], ['asc', 'asc'])

      return sorted
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dialogs/configure-ftp-dialog.vue